import React from 'react';
import { Navigate } from 'react-router-dom';
import { pr, r } from './helpers';
import { RiderV2Page, NotificationsPage, RiderShopOrderPage } from '../lazyPages';
import PortalLoginPage from '../../pages/shared/PortalLoginPage';

const RIDER = ['rider'];

/** Rider subdomain (rider-{slug}.domain) — authenticated → Rider v2. */
export function RiderSubdomainAuthRoutes() {
  return (
    <>
      {pr('/', RiderV2Page, RIDER)}
      {pr('/shop/:orderId', RiderShopOrderPage, RIDER)}
      {pr('/notifications', NotificationsPage, RIDER)}
      {r('/rider/notifications', <Navigate to="/notifications" replace />)}
      {r('/wallet', <Navigate to="/" replace />)}
      {r('/history', <Navigate to="/" replace />)}
      {r('/profile', <Navigate to="/" replace />)}
      {r('/login', <Navigate to="/" replace />)}
      {r('/rider_v2', <Navigate to="/" replace />)}
      {r('/rider_v2/login', <Navigate to="/login" replace />)}
    </>
  );
}

/** Rider subdomain — guest login. */
export function RiderSubdomainGuestRoutes() {
  return (
    <>
      {r('/', <PortalLoginPage portal="rider" />)}
      {r('/login', <PortalLoginPage portal="rider" />)}
      {r('/rider_v2', <Navigate to="/" replace />)}
      {r('/rider_v2/login', <Navigate to="/login" replace />)}
    </>
  );
}